<template>
  <Writeinspectionrecords/>
</template>
<script>
import Writeinspectionrecords from 'operations/inspection/writeinspectionrecords.vue'
export default {
    components:{
      Writeinspectionrecords
    }
}
</script>